import { render, staticRenderFns } from "./TransferFormDialog.vue?vue&type=template&id=4721bcda"
import script from "./TransferFormDialog.vue?vue&type=script&lang=js"
export * from "./TransferFormDialog.vue?vue&type=script&lang=js"
import style0 from "./TransferFormDialog.vue?vue&type=style&index=0&id=4721bcda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports